// CheckoutForm.js
import React, { Component } from "react";
import { Parse } from "parse";
import { injectStripe } from "react-stripe-elements";

import CardSection from "./cardSection";

import { Button, Form, Input, message, Row, Spin } from "antd";
import { Redirect } from "react-router-dom";

const FormItem = Form.Item;

class CheckoutForm extends Component {
  constructor() {
    super();
    this.state = {
      redirect:false,
      loading:false,
      name: null,
      elementFontSize: window.innerWidth < 450 ? "14px" : "18px"
    };
    window.addEventListener("resize", () => {
      if (window.innerWidth < 450 && this.state.elementFontSize !== "14px") {
        this.setState({ elementFontSize: "14px" });
      } else if (
        window.innerWidth >= 450 &&
        this.state.elementFontSize !== "18px"
      ) {
        this.setState({ elementFontSize: "18px" });
      }
    });
  }

  handleRedirection = () => {
    return (
      <Redirect to="profile"/>
    )
  }

  handleSubmit = ev => {
    ev.preventDefault();
    var ctx = this;

    this.props.form.validateFields(async (error, values) => {
    //  console.log("mes values : ", values);
    //  console.log("props stripe : ", ctx.props.stripe);
      if (error) {
        message.error("Certains champs ne sont pas correctement remplis");
      } else {
        if (ctx.props.stripe) {
          //création d'une "source" Stripe
          let result = await ctx.props.stripe.createSource({ type: "card" });
          //console.log("result: ", result);
          // si erreur, on arrête là et printe le message d'erreur
          if ("error" in result) {
            message.error(result.error.message);
          } else {
            //si 3D secure n'est pas nécessaire, on continue
            if (result.source.card.three_d_secure !== "required") {
              try {
                let card = await ctx.props.stripe.createToken({ name: values.name });
                console.log("card : ", card);
                console.log('props: ', ctx.props);
                console.log('couponType: ', ctx.props.couponType);
                ctx.setState({loading: true});

                //on est sur un one-shot
                if (!ctx.props.duration || ctx.props.duration <= 0.1){

                var response = await Parse.Cloud.run("Stripe", {
                  stripeToken: card.token,
                  amount: ctx.props.price * 100,
                  volume: ctx.props.volume,
                  diet: ctx.props.diet,
                  duration: ctx.props.duration,
                  couponType: ctx.props.couponType
                });
              }
              //on est sur une subscription
              else {
                console.log("coach? ", ctx.props.coach)
                var response = await Parse.Cloud.run("stripeSubscription", {
                  stripeToken: card.token,
                  amount: ctx.props.price * 100,
                  fees: ctx.props.fees,
                  diet: ctx.props.diet,
                  coach: ctx.props.coach,
                  duration: ctx.props.duration,
                  couponType: ctx.props.couponType

                });
              }
                console.log("Success : ", response);
                message.success("Ta transaction a bien été validée !");
                ctx.setState({loading: false, redirect: true})
              } catch (error) {
                console.log(error);
                message.error(error.message);
                ctx.setState({loading: false})
              }
            } else {
              message.error(
                "Le paiement 3D Secure n'est pas encore disponible"
              );
            }
          }
        } else {
          console.log("Stripe.js hasn't loaded yet.");
        }
      }
    });
  };

  onChange = e => {
    this.setState({
      name: e.target.value
    });
  };

  onRenderContent = () => {
    if (this.state.loading === false) {
      const { getFieldDecorator } = this.props.form;
      const { elementFontSize } = this.state;
      let fullName = Parse.User.current().attributes.firstName + " " + Parse.User.current().attributes.lastName
      //console.log("this.props : ", this.props)
      return (
        <Form onSubmit={this.handleSubmit}>
          <FormItem label="Prénom et nom du porteur de carte">
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: "Merci d'indiquer votre nom"
                }
              ],
              onChange: this.onChange,
              initialValue: fullName
            })(<Input />)}
          </FormItem>
          <FormItem label="Veuillez remplir vos informations bancaires.">
            <CardSection fontSize={elementFontSize} />
          </FormItem>
          <Row type="flex" justify="center">
            <Button type="primary" htmlType="submit">
              Confirmer
            </Button>
          </Row>
        </Form>
      )
    } else {
      return (
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{marginTop: 235, marginBottom: 235}}
        >
          <Spin size="large" />
        </Row>
      )
    }
  }

  render() {
    const {redirect} = this.state;
    if (redirect) {
      return (
        <Redirect to="profile"/>
      )
    } else {
      return (
        this.onRenderContent()
      )
    }
  }
}


const _CheckoutForm = Form.create()(CheckoutForm);

export default injectStripe(_CheckoutForm);
